import { Form, Formik, FormikProps } from 'formik';
import React, { useState } from 'react';
import Button, { ButtonThemes } from 'ui-components/button/button';
import { LabelModes } from 'ui-components/molecules/labeled-inputs/labeledInput';
import SlideOutSidebar from 'ui-components/slide-out-sidebar/slideOutSidebar';
import XGSFormDate from 'ui-components/form/date/xgsFormDate';
import { currentOrClosestBusinessDay } from 'hooks/utils';
import XGSFormInput from 'ui-components/form/input/xgsFormInput';
import '../cloneWeek.scss'
import { useCreateWeek, useUpdateWeek } from '../hooks/useWeek';
import { useSelector } from 'react-redux';
import { staticLoadSelector } from 'slices/static-load/staticLoadSlice';
import moment from 'moment';
import XGSFormSelect from 'ui-components/form/select/xgsFormSelect';
import { scheduleType } from 'app/data/static-load/model';

interface UpdateWeekSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  refetchGetWeeks: () => void;
  isEdit: boolean;
  editWeek: {
    weekStartDate: string;
    division: string;
    weekDescription: string;
    scheduleType: string;
  }
}

const UpdateWeek: React.FC<UpdateWeekSidebarProps> = ({ isOpen,
  onClose, refetchGetWeeks, isEdit, editWeek }) => {
  const [newWeekStartDate, setNewWeekStartDate] = useState<string | undefined>();

  const staticLoadSelectorData = useSelector(staticLoadSelector);
  const selectedDivision = staticLoadSelectorData.selectedDivision;
  // const weekStartDate = staticLoadSelectorData.weekStartDate;

  const createWeekMutation = useCreateWeek(() => {
    refetchGetWeeks();
    onClose();
  });

  const updateWeekMutation = useUpdateWeek(() => {
    refetchGetWeeks();
    onClose();
  });

  return <SlideOutSidebar
    show={isOpen}
    onClose={onClose}
    header={isEdit ? `Edit ${editWeek.weekStartDate}` : "Create Week"}
    size="small"
    className="filter-sidebar"
  >
    <Formik
      initialValues={{
        newWeekStartDate: isEdit ? editWeek.weekStartDate : "",
        weekDescription: isEdit ? editWeek.weekDescription : "",
        scheduleType: isEdit ? editWeek.scheduleType : ""
      }} onSubmit={(values) => {
        if (isEdit) {
          updateWeekMutation.mutate({
            division: editWeek.division,
            weekStartDate: editWeek.weekStartDate,
            weekDescription: values.weekDescription.trim(),
            scheduleType: values.scheduleType.trim()
          })
        }
        else {
          createWeekMutation.mutate({
            division: selectedDivision,
            weekStartDate: moment(newWeekStartDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
            weekDescription: values.weekDescription.trim(),
            scheduleType: values.scheduleType.trim()
          });
        }

      }}
      enableReinitialize
    >
      {(formikProps: FormikProps<any>) => (
        <Form>
          {!isEdit && <><XGSFormDate
            name="weekStartDate"
            label="Week Start Date:"
            placeholder="Select date..."
            onDateChange={(date) => { setNewWeekStartDate(date) }}
            value={newWeekStartDate}
            onChange={() => null}
            minDate={new Date(currentOrClosestBusinessDay())}
            required={true}
            labelMode={LabelModes.column}
            filterDate={(date) => date.getDay() === 1}
            disableWeekends={true}
          />
            <div style={{ marginTop: "10px" }} /></>}
          <XGSFormInput
            type="text"
            name="weekDescription"
            labelMode={LabelModes.column}
            label="Description"
          />
          <div style={{ marginTop: "10px" }} />
          {/* <XGSFormInput
            type="text"
            name="scheduleType"
            labelMode={LabelModes.column}
            label="Schedule Type"
          /> */}
          <XGSFormSelect
            label="Schedule Type"
            name="scheduleType"
            options={scheduleType}
            value={
              formikProps.values.scheduleType
                ? scheduleType.find((option) => option.value === formikProps.values.scheduleType)
                : null
            }
            onValueChange={(option) => {
              formikProps.setFieldValue("scheduleType", option?.value ?? "");
            }}
            formik
            // required={true}
            // className="add-edit-address-section__width-50"
            labelMode={LabelModes.column}
          />
          <div style={{ marginTop: "10px" }} />
          <div className="copy-move-lane-actions">
            <Button type="button" theme={ButtonThemes.gray} onClick={onClose}>Cancel</Button>
            <Button type="submit" theme={ButtonThemes.blue} spinner={createWeekMutation.isLoading} disabled={isEdit ? !formikProps.dirty : !newWeekStartDate}>Confirm</Button>
          </div>
        </Form>
      )}
    </Formik>
  </SlideOutSidebar >;
};

export default UpdateWeek;
